export default __webpack_public_path__ + "static/media/notebook.3393f3d6.png";